module.exports = __webpack_public_path__ + "img/231844.aacf5a06.png";